import { Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

/** Frame corner label (ON AIR / NEXT MEDIA) — theme-aware translucent chip for contrast on video. */
export function FlowControlPreviewFrameLabel({ label, color = '#fff' }: { label: string; color?: string }) {
  return (
    <Typography
      component="span"
      sx={{
        position: 'absolute',
        top: 8,
        left: 10,
        zIndex: 1,
        color,
        fontWeight: 700,
        fontSize: '0.95rem',
        lineHeight: 1.2,
        letterSpacing: 0.04,
        textTransform: 'uppercase',
        pointerEvents: 'none',
        userSelect: 'none',
        px: 0.75,
        py: 0.25,
        borderRadius: 0.5,
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark'
            ? alpha(theme.palette.common.black, 0.55)
            : alpha(theme.palette.common.white, 0.75),
      }}
    >
      {label}
    </Typography>
  );
}
